import { useQsFilters } from "@dash/filters";

import { BooleanFieldFilterOption, Serializers, SerializerValue } from "@megaron/serializers";

export const groupListFiltersSerializer = Serializers.object({
  searchText: Serializers.string,
  isArchived: Serializers.booleanFieldFilter,
  roles: Serializers.string.array(),
});

export type GroupListFilters = SerializerValue<typeof groupListFiltersSerializer>;

const defaultFilters: GroupListFilters = {
  searchText: "",
  isArchived: "false",
  roles: [],
};

export const parseIsArchivedOption = (option: BooleanFieldFilterOption): boolean | undefined =>
  option === "any" ? undefined : option === "true";

export const parseIsArchivedValue = (value: boolean | undefined): BooleanFieldFilterOption =>
  value === undefined ? "any" : value ? "true" : "false";

export const useGroupListFilters = () => {
  const { filters, setFilters } = useQsFilters(groupListFiltersSerializer, defaultFilters, "groupFilters");

  const setFilter =
    <TKey extends keyof GroupListFilters>(key: TKey) =>
    (value: GroupListFilters[TKey]) => {
      setFilters({ ...filters, [key]: value });
    };

  return { filters, setFilter, defaultFilters, setFilters };
};
